import DeleteIcon from '@mui/icons-material/Delete';
import { ListItemIcon, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { remixerApi } from 'services/api/remixer';
import { StyledMenuItem } from './styled';

const DeleteButton = ({ songId }: { songId: string }) => {
  const { t } = useTranslation();
  const [deleteSong] = remixerApi.useDeleteSongMutation();

  const handleDelete = () => deleteSong(songId);

  return (
    <StyledMenuItem onClick={handleDelete}>
      <ListItemIcon>
        <DeleteIcon />
      </ListItemIcon>
      <Typography>{t('library:studioSongs:deleteSong')}</Typography>
    </StyledMenuItem>
  );
};

export default DeleteButton;
